export enum ECode {
  ANN = 'ANN',
  SEM = 'SEM',
  TRI = 'TRI',
  MOIS = 'MOIS',
  PER = 'PER'
}
